"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  campaign_action_yes: {
    "id": "campaign_action_yes",
    "defaultMessage": "Yes"
  },
  campaign_action_no: {
    "id": "campaign_action_no",
    "defaultMessage": "No"
  },
  campaign_action_pass: {
    "id": "campaign_action_pass",
    "defaultMessage": "Pass"
  },
  campaign_action_fail: {
    "id": "campaign_action_fail",
    "defaultMessage": "Fail"
  },
  campaign_action_next: {
    "id": "campaign_action_next",
    "defaultMessage": "Next"
  },
  campaign_action_submit: {
    "id": "campaign_action_submit",
    "defaultMessage": "Submit sign-off"
  },
  campaign_sign_off: {
    "id": "campaign_sign_off",
    "defaultMessage": "Sign-off"
  },
  campaign_last_sign_off: {
    "id": "campaign_last_sign_off",
    "defaultMessage": "Last sign-off: {timeAgoLabel}"
  },
  campaign_type_answer: {
    "id": "campaign_type_answer",
    "defaultMessage": "Type your answer here"
  },
  campaign_your_name: {
    "id": "campaign_your_name",
    "defaultMessage": "Your name"
  },
  campaign_by_submitting: {
    "id": "campaign_by_submitting",
    "defaultMessage": "By submitting the sign-off you agree that this information will be visible to your supervisor."
  },
  campaign_submit_answers: {
    "id": "campaign_submit_answers",
    "defaultMessage": "Submit answer(s)"
  },
  campaign_minutes_ago: {
    "id": "campaign_minutes_ago",
    "defaultMessage": "{minutes, plural, one {# minute} other {# minutes}} ago at {timestamp}"
  },
  campaign_hours_ago: {
    "id": "campaign_hours_ago",
    "defaultMessage": "{hours, plural, one {# hour} other {# hours}} ago at {timestamp}"
  },
  campaign_days_ago: {
    "id": "campaign_days_ago",
    "defaultMessage": "{days, plural, one {# day} other {# days}} ago at {timestamp}"
  },
  campaign_months_ago: {
    "id": "campaign_months_ago",
    "defaultMessage": "{months, plural, one {# month} other {# months}} ago at {timestamp}"
  },
  campaign_years_ago: {
    "id": "campaign_years_ago",
    "defaultMessage": "{years, plural, one {# year} other {# years}} ago at {timestamp}"
  },
  ok: {
    "id": "ok",
    "defaultMessage": "Ok"
  },
  sign_off_submission_failure_title: {
    "id": "sign_off_submission_failure_title",
    "defaultMessage": "Unable to submit sign-off"
  },
  sign_off_submission_failure_subtitle: {
    "id": "sign_off_submission_failure_subtitle",
    "defaultMessage": "An error occurred while submitting the sign-off. Please try again."
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map